import { render } from "./ticketPresta.vue?vue&type=template&id=c62b844e"
import script from "./ticketPresta.vue?vue&type=script&lang=ts"
export * from "./ticketPresta.vue?vue&type=script&lang=ts"

import "./ticketPresta.vue?vue&type=style&index=0&id=c62b844e&lang=css"
script.render = render

export default script